// @ts-nocheck
/* eslint-disable react/no-array-index-key */
import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import qs from 'query-string';
import { withRouter } from '../../../../router-compat';

import configs from '../configs';
import { IntegrationLayout } from '../_shared';
import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import Select from '../../../ui/Select';
import FormGroup from '../../../ui/FormGroup';
import Pill from '../../../ui/Pill';
import Spinner from '../../../ui/Spinner';
import Empty from '../../../ui/Empty';

const SelectorCard = ({
  tone, title, link, idLabel, description, disabled, value, onChange, options, name,
}) => (
  <Card padded style={{ borderTop: `3px solid ${tone}` }}>
    <h4 className="m-0 mb-1 text-[14px] font-semibold">
      {title}{title === 'Tags' ? '' : ':'}{' '}
      {link && (
        <a href={link} target="_blank" rel="noopener noreferrer" className="text-mov-accent-ink underline font-normal">
          {idLabel}
        </a>
      )}
    </h4>
    {idLabel && !link && <div className="text-[12px] text-mov-ink-mute">{idLabel}</div>}
    <p className="m-0 mt-1 text-[12.5px] text-mov-ink-soft">{description}</p>
    {options && (
      <FormGroup className="mt-3">
        <Select disabled={disabled} value={value ?? ''} onChange={onChange} name={name}>
          <option value="">{title}…</option>
          {options.map((o) => <option key={o.key} value={o.value}>{o.text}</option>)}
        </Select>
      </FormGroup>
    )}
  </Card>
);

class GoogleTagManager extends Component {
  componentDidMount() {
    const gtm = this.props.store.integrations.GoogleTagManager;
    gtm.getConfigs();
    gtm.getAuthUrl();
    gtm.getAllResources();
    const { code, scope } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (code) {
      gtm.setup(code, scope).then(() => this.props.history.replace(this.props.location.pathname));
    }
  }

  onSelect = (name, value) => {
    this.props.store.integrations.GoogleTagManager.handleSelect(
      null,
      { name, value: value === '' ? null : Number(value) },
    );
  }

  render() {
    const gtm = this.props.store.integrations.GoogleTagManager;
    const {
      authUrl, loading, anyLoading, selected, accounts,
    } = gtm;
    const { accountIdx, containerIdx, workspaceIdx } = selected;

    const selectedAccount = accounts[accountIdx] || {};
    const containers = selectedAccount.containers || [];
    const selectedContainer = containers[containerIdx] || {};
    const workspaces = selectedContainer.workspaces || [];
    const selectedWorkspace = workspaces[workspaceIdx] || {};
    const tags = selectedWorkspace.tags || [];

    const allSelected = !_.some(selected, (idx) => idx === null || idx === undefined);

    return (
      <IntegrationLayout config={configs.GoogleTagManager}>
        <Card padded className="mb-5">
          <CardHead title="Setup" />
          <ol className="m-0 pl-5 flex flex-col gap-2 text-[13px] leading-relaxed">
            <li>Log in to <a href="https://tagmanager.google.com/" target="_blank" rel="noopener noreferrer" className="text-mov-accent-ink underline">Google Tag Manager</a>.</li>
            <li>
              <a href={authUrl} target="_blank" rel="noopener noreferrer" className="text-mov-accent-ink underline font-medium">
                Authorize Movology
              </a>{' '}— then refresh this page.
            </li>
            <li>Select your account, container, and workspace below.</li>
            <li>Capture tags appear with a green pill. Use &quot;Add Capture Tag&quot; if missing.</li>
            <li>After adding, &quot;Publish Workspace&quot; to go live.</li>
            <li>To remove the snippet later, remove the tag in GTM and publish.</li>
          </ol>
        </Card>

        <Card padded className="mb-5">
          <CardHead title="Settings" />
          {loading.getAllResources && <Spinner size={22} label="Loading resources…" />}

          <div
            className="grid gap-4 mt-3"
            style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}
          >
            <SelectorCard
              tone="var(--mov-danger)"
              title="Account"
              link={selectedAccount.accountId ? `https://tagmanager.google.com/#/container/accounts/${selectedAccount.accountId}/` : null}
              idLabel={selectedAccount.name || ''}
              description={selectedAccount.accountId ? `ID ${selectedAccount.accountId}` : 'Select your GTM account.'}
              disabled={loading.getAllResources}
              value={accountIdx ?? ''}
              onChange={(e) => this.onSelect('accountIdx', e.target.value)}
              options={accounts.map((a, i) => ({ key: a.path, value: i, text: `${a.name} — ${a.accountId}` }))}
              name="accountIdx"
            />
            <SelectorCard
              tone="var(--mov-warn)"
              title="Container"
              link={selectedContainer.tagManagerUrl}
              idLabel={selectedContainer.name || ''}
              description={selectedContainer.containerId ? `Public ID ${selectedContainer.publicId}` : 'Select a container.'}
              disabled={_.isEmpty(selectedAccount)}
              value={containerIdx ?? ''}
              onChange={(e) => this.onSelect('containerIdx', e.target.value)}
              options={containers.map((c, i) => ({ key: c.path, value: i, text: `${c.name} — ${c.containerId}` }))}
              name="containerIdx"
            />
            <SelectorCard
              tone="#43bccd"
              title="Workspace"
              link={selectedWorkspace.tagManagerUrl}
              idLabel={selectedWorkspace.name || ''}
              description={selectedWorkspace.workspaceId ? `ID ${selectedWorkspace.workspaceId}` : 'Select a workspace.'}
              disabled={_.isEmpty(selectedContainer)}
              value={workspaceIdx ?? ''}
              onChange={(e) => this.onSelect('workspaceIdx', e.target.value)}
              options={workspaces.map((w, i) => ({ key: w.path, value: i, text: `${w.name} — ${w.workspaceId}` }))}
              name="workspaceIdx"
            />
            <Card padded style={{ borderTop: '3px solid var(--mov-accent)' }}>
              <h4 className="m-0 mb-2 text-[14px] font-semibold">Tags</h4>
              {!selectedWorkspace.workspaceId ? (
                <Empty title="Select a workspace" sub="Tags will appear here." />
              ) : tags.length === 0 ? (
                <Empty title="No tags yet" sub="Add the Capture tag to start tracking." />
              ) : (
                <div className="flex flex-col gap-2">
                  {tags.sort((a, b) => a.tagId - b.tagId).map((t) => {
                    const isCapture = t.name.toLowerCase().includes('capture');
                    return (
                      <a
                        key={t.path}
                        href={t.tagManagerUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-[12.5px] p-2 rounded transition-colors"
                        style={{ border: '1px solid var(--mov-line)', background: 'var(--mov-paper-2)' }}
                      >
                        <Pill tone={isCapture ? 'green' : 'gray'} dot>{isCapture ? 'Capture' : 'Other'}</Pill>
                        <span className="mov-mono text-[11.5px] text-mov-ink-mute">#{t.tagId}</span>
                        <span className="truncate text-mov-ink">{t.name}</span>
                      </a>
                    );
                  })}
                </div>
              )}
            </Card>
          </div>
        </Card>

        <Card padded>
          <div className="flex gap-2 justify-end flex-wrap">
            <Button
              disabled={anyLoading || selected.containerIdx === null || selected.containerIdx === undefined}
              loading={loading.createWorkspace}
              onClick={gtm.createWorkspace}
            >
              Create workspace
            </Button>
            <Button
              variant="primary"
              disabled={anyLoading || !allSelected}
              loading={loading.addCaptureTag}
              onClick={gtm.addCaptureTag}
            >
              Add Capture tag
            </Button>
            <Button
              variant="accent"
              disabled={anyLoading || !allSelected}
              loading={loading.publishWorkspace}
              onClick={gtm.publishWorkspace}
            >
              Publish workspace
            </Button>
          </div>
        </Card>
      </IntegrationLayout>
    );
  }
}

export default withRouter(inject('store')(observer(GoogleTagManager)));
